import React from 'react';
import { properties } from '../../properties';

/**
 * Generates hidden input fields for WPG_CUSTOM_BASKET variables based on basketCount.
 * @param {number} basketCount - Number of basket items.
 * @returns {React.ReactNode[]} Array of hidden input elements.
 */

export function getBasketCustomVars(basketCount = 3) {
    const custom_vars = [];

    // WPG_CUSTOM_variables
    for(var custom in properties.WPG_CUSTOM_variables){
        custom_vars.push(<input type="hidden" name={custom} value={properties.WPG_CUSTOM_variables[custom]} key={custom}/>);
    }
    
    // Basket item variables
    for (let i = 1; i <= basketCount; i++) {
        custom_vars.push(
            <input
                type="hidden"
                name={`WPG_CUSTOM_BASKET_${i}_name`}
                value={`Test item ${i} which has a very long text`}
                key={`WPG_CUSTOM_BASKET_${i}_name`}
            />
        );
        custom_vars.push(
            <input
                type="hidden"
                name={`WPG_CUSTOM_BASKET_${i}_price`}
                value="75.00"
                key={`WPG_CUSTOM_BASKET_${i}_price`}
            />
        );
        custom_vars.push(
            <input
                type="hidden"
                name={`WPG_CUSTOM_BASKET_${i}_desc`}
                value={`A lovely test item numbered ${i} in green`}
                key={`WPG_CUSTOM_BASKET_${i}_desc`}
            />
        );
        custom_vars.push(
            <input
                type="hidden"
                name={`WPG_CUSTOM_BASKET_${i}_qty`}
                value="1"
                key={`WPG_CUSTOM_BASKET_${i}_qty`}
            />
        );
        custom_vars.push(
            <input
                type="hidden"
                name={`WPG_CUSTOM_BASKET_${i}_total`}
                value="75.00"
                key={`WPG_CUSTOM_BASKET_${i}_total`}
            />
        );
    }

    // WPG_CUSTOM_BASKET_count
    custom_vars.push(
        <input
            type="hidden"
            name="WPG_CUSTOM_BASKET_count"
            value={basketCount}
            key="WPG_CUSTOM_BASKET_count"
        />
    );

    // WPG_CUSTOM_BASKET_subtotal
    custom_vars.push(
        <input
            type="hidden"
            name="WPG_CUSTOM_BASKET_subtotal"
            value={(basketCount * 75).toFixed(2)}
            key="WPG_CUSTOM_BASKET_subtotal"
        />
    );
    // WPG_CUSTOM_BASKET_total
    custom_vars.push(
        <input
            type="hidden"
            name="WPG_CUSTOM_BASKET_total"
            value={(basketCount * 75 + 10).toFixed(2)}
            key="WPG_CUSTOM_BASKET_total"
        />
    );
    return custom_vars;
}
